<template>
  <div class="course-content-header d-flex align-items-center" :style="{ backgroundImage: `url(${course?.cover})` }">
    <div class="info">
      <h1 class="fw-bold">{{ course?.name }}</h1>
      <p>{{ course?.description }}</p>
      <div class="btns-container">
        <template v-if="course?.course_id && watch_lesson?.id && course?.has_subscription">
          <router-link class="watch buts"
            :to="{ name: 'lesson', params: { course_id: course?.course_id, lesson_id: watch_lesson?.id } }">
            <CaPlayFilledAlt />
            مشاهده : {{ watch_lesson?.name }}
          </router-link>
        </template>
        <router-link :to="{ name: 'episodes', params: { id: course?.course_id } }" class="course-content buts">
          <FlLayerDiagonal />
          المحتوي
        </router-link>
      </div>
      <template v-if="!course?.has_subscription">
        <div class="subscriptions-btn d-flex align-items-center">
          <router-link class="subscribe-btn" :to="{
            name: 'payment',
            params: { id: course?.course_id },
            query: { free: course?.free },
          }">اشترك الان</router-link>
          <button  v-if="course?.free == false" @click="activate_course_by_code(course?.course_id)"
            class="subscribe-btn">
            تفعيل الكورس بالكود
          </button>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import config from '@/services/config';
import {
  FlLayerDiagonal,
  CaPlayFilledAlt
} from '@kalimahapps/vue-icons';
import axios from 'axios';
import Swal from 'sweetalert2';
export default {
  name: "CourseContentHeaderComponent",
  components: {
    FlLayerDiagonal,
    CaPlayFilledAlt
  },
  props: ['course', 'getHumanDate', 'watch_lesson'],
  data() {
    return {
      is_ready: false
    }
  },
  mounted() {
    console.log('lesson', this.watch_lesson, this.course)
  },
  watch: {
  },
  methods: {
    change_ready() {
      this.is_ready = true
    } ,
    activate_course_by_code(course_id) {
      Swal.fire({
        title: "اكتب كود تفعيل الكورس",
        input: "text",
        imageUrl: this.data?.cover,
        imageHeight: "200",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "تفعيل",
        cancelButtonText: "الغاء",
        showLoaderOnConfirm: true,
        preConfirm: (login) => {
          if (login == null || login.length == 0) {
            Swal.fire({
              text: "اكتب الكود عشان تعرف تفعل الكورس",
              icon: "warning",
            });
            return;
          }

          this.is_activating = true;
          axios
            .post(
              `${config.basURL}codes/active-course-code`,
              {
                course_id: course_id,
                course_code: login,
              },
              {
                headers: {
                  auth: this.$store.state.userToken,
                },
              }
            )
            .then(() => {
              Swal.fire({
                text: "تم تفعيل الكورس بنجاح هتلاقي الكورس دلوقتي في كورساتي ",
                icon: "success",
              });
              this.$router.push({ name: "user_courses" });
            })
            .catch((err) => {
              console.log(err);
              if (err.response.status == 400) {
                Swal.fire({
                  text: err.response.data.detail,
                  icon: "error",
                });
              } else if (err.response.status == 404) {
                Swal.fire({
                  text: "الكود غلط اكتب الكود الصح ",
                  icon: "error",
                });
              }
              else {
                Swal.fire({
                  text: "حدث خطاء",
                  icon: "error",
                });
              }
            })
            .finally(() => {
              this.is_activating = false;
            });
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    },
  }
};
</script>

<style scoped>
.course-content-header {
  /* background-color: #000; */
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
  z-index: 1;
}

.course-content-header::after {
  content: '';
  background: linear-gradient(90deg, rgba(15, 10, 5, 0) 56%, rgba(15, 10, 5, .4) 64%, rgba(15, 10, 5, .7) 80%, rgba(15, 10, 5, .8) 92%);
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
}

.course-content-header * {
  color: #FFFFFF;
}

.info {
  padding: 0 3rem;
}

.btns-container {
  padding: 2rem 0;
}

.buts {
  all: unset;
  padding: 0.8rem 2rem;
  background-color: #ffffff1a;
  /* border: 1px solid #fff; */
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1.8rem;
}

.subscribe-btn {
  all: unset;
  padding: 0.5rem 2rem;
  border-radius: 0.5rem;
  cursor: pointer;
  background-color: #f1c40f;
  color: #000;
  text-align: center;
  margin-left: 0.8rem;
  font-weight: bold;
  transition: all 0.5s ease;
}
.subscribe-btn:hover {
  background-color:#f39c12;
}
@media(max-width:767px) {
  .info {
    padding: 0 1rem;
  }

  .btns-container {
    padding: 2rem 0;
    display: flex;
    flex-direction: column;
  }

  .buts {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
}

.watch {
  background: #fff;
  color: #000 !important;
  margin-left: 0.8rem;
}

.watch * {
  color: #000 !important;
}
</style>
